export const SET_USER_NAME = 'SET_USER_NAME';
export const SET_USER_IMAGES = 'SET_USER_IMAGES';

export const setUserName = payload => ({type: SET_USER_NAME, payload});
export const setUserImages = payload => ({type: SET_USER_IMAGES, payload});

export const setUserProfile = simplifiedUserProfile => {
    return dispatch => {
        dispatch(setUserName(simplifiedUserProfile.name));
        dispatch(setUserImages(simplifiedUserProfile.images));
    }
}